import { mapState } from 'vuex';

import payloadWizardQuery from '@/components/private/logs/payloads/wizard_query/index.vue'

export default {
    name: 'wai_logs',
    props: {
    },

    components : {
        payloadWizardQuery
    },

    data : function(){

        return {
            loading : true,
            logs : null,
            additional : null
        }

    },

    created : function(){
        this.get()
    },

    watch: {
        
    },

    beforeRouteEnter (to, from, next) {
        next()
    },

    beforeRouteUpdate (to, from, next) {
        next()
    },

    computed: mapState({
        auth : state => state.auth,
    }),

    methods : {
        get : function(){

            var t = this

            t.loading = true

            this.$root.api.app.logs.get().then(data => {

            
                this.logs = t.$root.f.ungroup(data.groups)
                this.additional = data.additional


                t.loading = false
            })
        }
    },
}